import ReactDOM from 'react-dom'
import App from './App'
import 'src/providers/i18n'

ReactDOM.render(<App />, document.getElementById('root'))
